import * as React from 'react'
import type { AccountPlan } from 'types/business2020'
import styles from './index.module.css'

type Props = {
  plan: AccountPlan
  children: React.ReactNode
  isPlanChange: boolean
}

const ChosenBadge = (props: Props): React.ReactNode => {
  const { plan, children, isPlanChange } = props
  return (
    <>
      <div
        className={styles.pricingPlanChosenLine}
        style={{ ...plan.chosenColor.line }}
      >
        {plan.recommended && !isPlanChange && (
          <span className={styles.pricingPlanChosenLineText}>RECOMMENDED</span>
        )}
      </div>

      {children}
    </>
  )
}

export default ChosenBadge
